import { render, staticRenderFns } from "./LandingGestionClient.vue?vue&type=template&id=48b6c8fa&scoped=true"
import script from "./LandingGestionClient.vue?vue&type=script&lang=js"
export * from "./LandingGestionClient.vue?vue&type=script&lang=js"
import style0 from "./LandingGestionClient.vue?vue&type=style&index=0&id=48b6c8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b6c8fa",
  null
  
)

export default component.exports